﻿//Majority of source code taken from https://github.com/JamesRandall/react-azure-adb2c
//Updated to work with a later version of the msal library for ie11 support

import * as Msal from "@azure/msal-browser";
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { store } from 'state';
import { ResetStore } from 'state/actions';

const state = {
    accessToken: null,
    signedIn: false
}

var msalObj;
var tokenRequestObj;
var loginRequestObj;

function acquireToken(successfulCallback) {

    if(msalObj == null) {
        return;
    }

    //Get all tokens from storage
    const currentAccounts = msalObj.getAllAccounts();

    //If there is nothing in storage, redirect the user to login
    if (currentAccounts.length === 0) {
        redirectToLogin(successfulCallback);
    } else if (currentAccounts.length > 1) {
        //We have found more than 1 account, we should log them out
        authentication.signOut();
    } else if (currentAccounts.length === 1) {
        //SSO already exists, lets get a new token if needed
        acquireSilentToken(successfulCallback);
    }
}

function redirectToLogin(successfulCallback) {

    //Set up the callback for getting a token, this is used by the redirect and by getting a silent token
    msalObj.handleRedirectPromise()
        .then((response) => {
        handleResponse(response, successfulCallback);
    })
    .catch(() => {
        //Something has gone wrong, try to log them out
        authentication.signOut();
    });
}

function handleResponse(response, successfulCallback) {

    //If there is a response, then this is a callback, otherwise it is the first pass through
    if (response) {

        // if response contains an access token, store it and we have logged in successfully
        if (response.accessToken && response.accessToken !== "") {
            state.signedIn = true;
            state.accessToken = response;

            if (successfulCallback) {
                successfulCallback();
            }
        }

        //If a cookie was set for the return page, we can now just switch to it.
        var redirectUrl = Cookies.get('return');
        if (redirectUrl != null) {
            Cookies.remove('return');
            window.location = redirectUrl;
        }

    } else {
        localStorage.clear();
        //no callback, so can navigate the user to the login screen.
        msalObj.loginRedirect(loginRequestObj);
    }
}

function acquireSilentToken(successfulCallback) {

    //User account already present, just refresh the token if needed.
    var request = {
        ...tokenRequestObj
    };
    request.account = msalObj.getAllAccounts()[0];

    return msalObj.acquireTokenSilent(request)
        .then((response) => {
            // In case the response from B2C server has an empty accessToken field
            // throw an error to initiate token acquisition
            if (!response.accessToken || response.accessToken === "") {
                throw new Msal.InteractionRequiredAuthError;
            }
            return handleResponse(response, successfulCallback);
        })
        .catch(error => {

            localStorage.clear();

            //If getting a token silently fails, then we redirect them to get a token
            if (error instanceof Msal.InteractionRequiredAuthError) {
                return msalObj.acquireTokenRedirect(request);
            }

            return null;
            
        });
}

export const authentication = {
    initialize: async (msalConfig, loginRequest, tokenRequest) => {
        msalObj = new Msal.PublicClientApplication(msalConfig);
        await msalObj.initialize();
        tokenRequestObj = tokenRequest;
        loginRequestObj = loginRequest;
    },
    run: (successfulCallback) => {
        acquireToken(successfulCallback);
    },
    rechallenge: () => {
        localStorage.clear();
        redirectToLogin();
    },
    forceLogin: (customParams) => {
        localStorage.clear();
        
        const forceLoginRequestObj = {
            ...loginRequestObj,
            prompt: "login",
        };

        if (customParams) {
            forceLoginRequestObj.extraQueryParameters = customParams;
        }

        msalObj.loginRedirect(forceLoginRequestObj);
    },
    // Per-app eject to the logged-out landing page. Clears this app's local state and redirects,
    // but deliberately does not call logoutRedirect so the shared B2C SSO session survives and the
    // user stays signed in to their other Vision apps.
    ejectSupersededSession: () => {
        const token = authentication.getAccessToken();
        let signOutUrl = window.env.SSO_SIGN_OUT_URL;

        if (token != null && token.idTokenClaims != null && token.idTokenClaims.extension_SignOutUrl != null) {
            signOutUrl = token.idTokenClaims.extension_SignOutUrl;
        }

        localStorage.clear();
        window.location.assign(signOutUrl);
    },
    required: (WrappedComponent) => {
        return function RequiredAccess() {

            const [signedIn, setSignedIn] = useState(null);
            useEffect(function () {

                if(msalObj == null) {
                    return;
                }

                acquireToken(() => {
                    setSignedIn(true);
                });
            }, [msalObj]);

            return signedIn === true ? (<WrappedComponent />) : null;
        };
    },
    onHoldRedirect: () => {
        window.location = window.env.VISION_URL;
    },
    anonymousAccess: (WrappedComponent) => {
        return function AnonymousAccess() {

            const [signedIn, setSignedIn] = useState(null);

            useEffect(function () {
                const currentAccounts = msalObj.getAllAccounts();
                if (currentAccounts.length === 0) {
                    setSignedIn(false);
                } else {
                    window.location = "/";
                }
            }, []);

            return signedIn === false ? (<WrappedComponent />) : null;
        };
    },
    signOut: () => {

        var token = authentication.getAccessToken();
        var logoutConfig = {};

        if (token != null && token.idTokenClaims != null && token.idTokenClaims.extension_SignOutUrl != null) {
            logoutConfig.postLogoutRedirectUri = token.idTokenClaims.extension_SignOutUrl;
        }

        msalObj.logoutRedirect(logoutConfig);
        setTimeout(() => {
            //This can cause issues on the front end when logging out so we'll give a small delay.
            store.dispatch(ResetStore());
        },100);
    },
    getAccessToken: () => {
        return state.accessToken;
    }
}